import PropTypes from 'prop-types';
import Icon from '@/components/ui/AppIcon';

const EmptyCart = ({ onContinueShopping }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 md:py-16 lg:py-16 px-4">
      <div className="w-32 h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 bg-muted rounded-full flex items-center justify-center mb-6">
        <Icon name="ShoppingCartIcon" size={80} className="text-muted-foreground" />
      </div>
      
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-3 text-center">
        Your Cart is Empty
      </h2>
      
      <p className="text-sm md:text-base caption text-muted-foreground text-center max-w-md mb-8">
        Looks like you haven't added any spare parts to your cart yet. Browse our extensive catalog of JCB and earthmoving equipment parts.
      </p>

      <button
        onClick={onContinueShopping}
        className="h-12 md:h-14 px-6 md:px-8 bg-primary hover:bg-primary/90 text-primary-foreground font-semibold rounded-md transition-smooth focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3 flex items-center gap-2"
      >
        <Icon name="MagnifyingGlassIcon" size={20} />
        <span>Browse Products</span>
      </button>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8 w-full max-w-3xl">
        <div className="flex flex-col items-center text-center">
          <div className="w-12 h-12 md:w-16 md:h-16 bg-primary/10 rounded-full flex items-center justify-center mb-3">
            <Icon name="CubeIcon" size={24} className="text-primary" />
          </div>
          <h3 className="text-sm md:text-base font-semibold text-foreground mb-1">500+ Parts</h3>
          <p className="text-xs caption text-muted-foreground">Extensive catalog of genuine spare parts</p>
        </div>

        <div className="flex flex-col items-center text-center">
          <div className="w-12 h-12 md:w-16 md:h-16 bg-primary/10 rounded-full flex items-center justify-center mb-3">
            <Icon name="TruckIcon" size={24} className="text-primary" />
          </div>
          <h3 className="text-sm md:text-base font-semibold text-foreground mb-1">Fast Delivery</h3>
          <p className="text-xs caption text-muted-foreground">Domestic and international shipping</p>
        </div>

        <div className="flex flex-col items-center text-center">
          <div className="w-12 h-12 md:w-16 md:h-16 bg-primary/10 rounded-full flex items-center justify-center mb-3">
            <Icon name="ShieldCheckIcon" size={24} className="text-primary" />
          </div>
          <h3 className="text-sm md:text-base font-semibold text-foreground mb-1">Quality Assured</h3>
          <p className="text-xs caption text-muted-foreground">Export quality certified products</p>
        </div>
      </div>
    </div>
  );
};

EmptyCart.propTypes = {
  onContinueShopping: PropTypes?.func?.isRequired
};

export default EmptyCart;